<template>
  <li class="search-results__item">
    <p v-if="section" class="search-results__overline">{{ section }}</p>
    <h3 class="search-results__title"><a :href="url">{{ title }}</a></h3>

    <div v-if="summary" class="search-results__summary">
      <p><span v-html="summary"></span></p>
    </div>
  </li>
</template>

<script>
  export default {
    props: {
      title: String,
      url: String,
      section: String,
      summary: String,
    }
  }
</script>
